/** True for a yyyyMMdd value that is a real calendar date; empty, zero placeholders ('00000000') and impossible dates are false. */
export const isValidYmdDate = (value: unknown): boolean => {
    const s = String(value ?? '').trim()
    if (!/^\d{8}$/.test(s)) return false
    const year = Number(s.slice(0, 4))
    const month = Number(s.slice(4, 6))
    const day = Number(s.slice(6, 8))
    if (year === 0) return false
    const date = new Date(year, month - 1, day)
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}
